exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login_box[data-v-5e62eb23]{-webkit-transform:translateY(30%);-moz-transform:translateY(30%);-ms-transform:translateY(30%);transform:translateY(30%)}.or-separator[data-v-5e62eb23]{text-align:center;padding:1rem 0;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.5rem}.or-separator[data-v-5e62eb23]:after,.or-separator[data-v-5e62eb23]:before{content:\"\";width:1rem;height:2px;background-color:#c5c5c5}", ""]);

// exports
